export { default } from "../.internal/git/amcharts4-lang/src/en";


// WEBPACK FOOTER //
// ../../../src/lang/en.ts